import React from 'react';
import { withRouter } from 'react-router';
import Error from '../../components/Error';
import { FormattedMessage } from 'react-intl';

const error = {
  message: <FormattedMessage id="ErrorComponent.errors.not_found.message" />,
  code: <FormattedMessage id="ErrorComponent.errors.not_found.code" />
};

export default withRouter(
  props => <Error error={error} {...props} />
);

